import { render, staticRenderFns } from "./Input2Range.vue?vue&type=template&id=1dd65c94&"
import script from "./Input2Range.vue?vue&type=script&lang=js&"
export * from "./Input2Range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports